import { render } from "./SpiritOfJapan4.vue?vue&type=template&id=c1b54158&scoped=true"
import script from "./SpiritOfJapan4.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan4.vue?vue&type=script&lang=js"

import "./SpiritOfJapan4.scss?vue&type=style&index=0&id=c1b54158&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b54158"]])

export default __exports__